









import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import { DeveloperPresentableMixin } from "../../../developer/mixins";

@Component
export default class FormatMenu extends Mixins(ModelEditableMixin, DeveloperPresentableMixin) {
  get originalId(): string {
    return this.readPropertyOrDefault(s => s.attributes.format.originalId.toString(), "");
  }

  get name(): string {
    return this.readPropertyOrDefault(s => s.attributes.format.name, "");
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }
}
